import { axios } from '/plugins/axios.client';
import { errorFromResponse } from '/src/common/general-utils';
import { i18n } from '/plugins/i18n.client';
const errorHandler = errorFromResponse(i18n.global.t.bind(i18n));
import { toast } from '/plugins/toaster.client.js';

/**
 * @method getEndpointServerByUUID
 * @description     *
 * Method can be used to get the detail of the specific endpoint-server.
 * @param {string} UUID is the unique Id of the endpoint-server.
 */
export const getEndpointServerByUUID = async (UUID) => {
  try {
    const endpointServerDetails = await axios.$get('/api/endpoint-server/' + UUID);
    return { ...endpointServerDetails, Active: endpointServerDetails.Active ? 1 : 0 };
  } catch (error) {
    toast.error(errorHandler('admin.endpoint_server.action_list.fetch_endpoint_servers', error));
    return {};
  }
};

/**
 *@method updateEndpointServer
 * @description
 * Method to update the endpoint-server.
 * @param {object} endpointServerDetail is the complete detail of endpoint-server that to be updated.
 *
 * @return {boolean} based on whether successfully saved or not
 */
export const updateEndpointServer = async (endpointServerDetail) => {
  try {
    await axios.$put('/api/endpoint-server', endpointServerDetail);
    toast.success(
      i18n.global.t('admin.dynamic_labels.save_success', {
        feature: i18n.global.t('admin.feature.endpoint_server')
      })
    );
    return true;
  } catch (error) {
    toast.error(errorHandler('admin.endpoint_server.action_list.saving_endpoint', error));
    return false;
  }
};

/**
 * @method deleteEndpointServer
 * @description
 * Method to delete the variable from the list.
 * @param {Array} UUIDs is the unique Id of the servers that to be deleted.
 *
 * @returns {boolean} based on whether the endpoint's were deleted successfully or not
 */
export const deleteEndpointServer = async (UUIDs) => {
  try {
    // Api call to remove endpoint's
    await axios.$delete('/api/endpoint-server', {
      data: {
        uuids: UUIDs
      }
    });

    // Toast for successful removal of endpoint server's
    toast.success(
      i18n.global.t('admin.dynamic_labels.delete_success', {
        feature: i18n.global.t('admin.feature.endpoint_server')
      })
    );
    return true;
  } catch (error) {
    // Toast for failure in removal of endpoint server's
    toast.error(
      errorHandler(
        i18n.global.t('admin.dynamic_labels.deleting_action', {
          feature: i18n.global.t('admin.feature.endpoint_server', 2)
        }),
        error
      )
    );
    return false;
  }
};

/**
 *
 * Method to fetch list of storage accounts
 * @param {String} environmentName is the name of environment
 */
export const fetchStorageAccounts = async (environmentName) => {
  try {
    const data = await axios.$get('/api/admin/azureResources/' + environmentName);
    if (data.length > 0) {
      return data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

/**
 * @method getEndpointServersList
 * @description
 * Method is used to fetch the entire list of the endpoint-servers.
 */
export const getEndpointServersList = async () => {
  try {
    return await axios.$get('/api/endpoint-server');
  } catch (error) {
    toast.error(errorHandler('admin.endpoint_server.action_list.retrieve_endpoint_list', error));
    return [];
  }
};
